import React, { useState } from 'react';
import { Card } from 'antd';
import { useRoleGuard, UserRole } from 'shared/hooks/use-role-guard';
import { DocumentsList } from 'components/documents/documents-list';
import { DocumentsUpload } from 'components/documents/documents-upload';
import { ExpensesListWithCreateButton } from 'components/expenses/expenses-list-with-create-button';
import { InvoicesListWithCreateButton } from 'components/invoices/invoices-list-with-create-button';
import { WhTaskItemsTable } from 'components/wh-tasks/wh-task-items-table';
import { getTabsList } from './constants';
import { EWhTaskMainTabs, type IWhTaskMainProps } from './types';

export const WhTaskMain = (props: IWhTaskMainProps) => {
  const { whTaskId } = props;
  const [activeTabKey, setActiveTabKey] = useState<EWhTaskMainTabs>(EWhTaskMainTabs.items);
  const isInvoicesTabVisible = useRoleGuard([UserRole.admin, UserRole.assistant, UserRole.accountant]) ?? false;
  const isExpensesTabVisible = useRoleGuard([UserRole.admin, UserRole.assistant, UserRole.accountant]) ?? false;

  const onTabChange = (key: string) => {
    setActiveTabKey(key as EWhTaskMainTabs);
  };

  const contentListNoTitle: Record<EWhTaskMainTabs, React.ReactNode> = {
    [EWhTaskMainTabs.items]: <WhTaskItemsTable whTaskId={whTaskId} />,
    [EWhTaskMainTabs.documents]: (
      <>
        <DocumentsUpload whTaskId={whTaskId} />
        <DocumentsList whTaskId={whTaskId} />
      </>
    ),
    [EWhTaskMainTabs.invoices]: isInvoicesTabVisible ? <InvoicesListWithCreateButton whTaskId={whTaskId} /> : null,
    [EWhTaskMainTabs.expenses]: isExpensesTabVisible ? <ExpensesListWithCreateButton whTaskId={whTaskId} /> : null,
  };
  const tabs = getTabsList(isInvoicesTabVisible, isExpensesTabVisible);

  return (
    <Card style={{ width: '100%' }} tabList={tabs} activeTabKey={activeTabKey} onTabChange={onTabChange}>
      {contentListNoTitle[activeTabKey]}
    </Card>
  );
};
